export default "__VITE_ASSET__BsrcUqxP__"